import { View, Text } from '@react-pdf/renderer'
import React from 'react'
import MeasureBox from './MeasureBox'

const QualityBomMeasureSummary = ({data, order}) => {
  return (
    <View
        style={{
            flexDirection: "row",
            padding: "10px"
        }}
    >
        <MeasureBox 
            image={"/images/check.png"}
            title="QUALITY CHECK"
            critical={ order.job_order_meta ? order.job_order_meta.total_quality_check_critical_item: "-"}
            major={ order.job_order_meta ? order.job_order_meta.total_quality_check_critical_item: "-"}
            minor={ order.job_order_meta ? order.job_order_meta.total_quality_check_critical_item: "-"}
            viewStyles={{
                marginRight: "5px"
            }}
        />
        <MeasureBox 
            image={"/images/ruler.png"}
            title="MEASURES CHECK"
            critical={order.job_order_meta ? order.job_order_meta.total_measure_check_critical_item : "-"}
            major={"-"}
            minor={"-"}
            viewStyles={{
                marginRight: "5px"
            }}
        />
        <MeasureBox 
            image={"/images/bom.png"}
            title="BOM CHECK"
            critical={"-"}
            major={"-"}
            minor={"-"}
        />
    </View>
  )
}

export default QualityBomMeasureSummary